import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "deployment-view" }
const _hoisted_2 = { class: "text-wrap text-truncate" }
const _hoisted_3 = { class: "dt-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Quickly setup multiple Ditto rooms by selecting the receiver to assign for each room. The room and receiver will automatically link.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "primary-color",
        to: "/organization/deployment"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Deployment")
        ]),
        _: 1
      }),
      _createTextVNode(" » Quick Link ")
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createVNode(_component_el_form, { "label-position": "top" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            class: "mb-0",
            label: "Link Receivers to Rooms"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_table, {
            data: _ctx.receivers,
            style: {"width":"100%"},
            "empty-text": "No devices available to link."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { prop: "displayName" }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_router_link, {
                    to: `/receivers/${scope.row.id}`,
                    target: "_blank",
                    rel: "noreferrer noopener"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.displayName), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("p", null, _toDisplayString(scope.row.deviceType), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { prop: "roomName" }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.roomToLink,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roomToLink) = $event)),
                    placeholder: _ctx.noRoomsAvailablePlaceholder(scope.row.availableRooms),
                    filterable: "",
                    "default-first-option": "",
                    disabled: _ctx.noRoomsAvailable(scope.row.availableRooms),
                    onChange: ($event: any) => (_ctx.handleSelection(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.availableRooms, (room) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: room.id,
                          value: room.id,
                          label: room.roomName
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(room.roomName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "placeholder", "disabled", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      })
    ])), [
      [_directive_loading, _ctx.viewLoading]
    ])
  ]))
}